import { ASSISTANT_NAME } from '../brand.js';
export function CardPolicyNotice({ required, onReview, disabled = false }) {
  if (!required) return null;
  return <section role="status" class="card" style={{ margin: '1rem', padding: '1rem', lineHeight: 1.5 }}>
    <p style={{ margin: '0 0 0.75rem' }}>One booking detail needs your confirmation: should clients save a card before booking? {ASSISTANT_NAME} will use your choice for new appointments.</p>
    <button type="button" disabled={disabled} onClick={onReview} style={{ minHeight: '44px', padding: '0.65rem 1rem', borderRadius: '8px', border: 'none', background: 'var(--sage)', color: 'white', font: 'inherit', cursor: 'pointer' }}>Review card requirement</button>
  </section>;
}
